export default function formFilter(form) {
  const container = document.getElementById('list-products');
  form.addEventListener('change', () => {
    let products_types = [];
    let bead_sizes = [];
    let specialites = [];
    let ranges = [];
    let production_sites = [];
    const products_typesEl = form.querySelectorAll('.product_type:checked');
    const bead_sizesEl = form.querySelectorAll('.bead_size:checked');
    const specialitesEl = form.querySelectorAll('.speciality:checked');
    const rangesEl = form.querySelectorAll('.range:checked');
    const production_sitesEl = form.querySelectorAll('.production_site:checked');
    for(var i=0; i<products_typesEl.length; i++) {
      products_types.push(products_typesEl[i].value);
    }
    for(var x=0; x<bead_sizesEl.length; x++) {
      bead_sizes.push(bead_sizesEl[x].value);
    }
    for(var y=0; y<specialitesEl.length; y++) {
      specialites.push(specialitesEl[y].value);
    }
    for(var z=0; z<rangesEl.length; z++) {
      ranges.push(rangesEl[z].value);
    }
    for(var c=0; c<production_sitesEl.length; c++) {
      production_sites.push(production_sitesEl[c].value);
    }
    
    products_types = (products_types.length > 0) ? products_types.join(',') : 0;
    bead_sizes = (bead_sizes.length > 0) ? bead_sizes.join(',') : 0;
    specialites = (specialites.length > 0) ? specialites.join(',') : 0;
    ranges = (ranges.length > 0) ? ranges.join(',') : 0;
    production_sites = (production_sites.length > 0) ? production_sites.join(',') : 0;

    const endpoint = `/wp-json/api/fetch/products/?products_types=${products_types}&bead_sizes=${bead_sizes}&specialites=${specialites}&ranges=${ranges}&production_sites=${production_sites}`;
    fetch(endpoint)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        container.innerHTML = result;
        // container.classList.toggle('d-none');
        // loader.classList.toggle('d-none');
      });
  });
}


// WEBPACK FOOTER //
// ./scripts/components/filter-table.js